// Copyright (C) Siemens AG 2026. All rights reserved. Confidential
// Standalone routes with lazy loading — each route loads its component on demand
import { Routes } from '@angular/router';
import { SelectedTenantGuard } from './guards/selected-tenant.guard';
import { AuthGuard } from './guards/auth.guard';
import { SuspendedTenantGuard } from './guards/suspended-tenant.guard';
import { LoginPageGuard } from './guards/login-page.guard';
import { PricingAndSubtenantsGuard } from './guards/pricing-and-subtenants.guard';
import { SubTenantsAreaGuard } from './guards/sub-tenants-area.guard';
import { OrdersOrAccountGuard } from './guards/orders-or-account.guard';

export const routes: Routes = [{
  path: '',
  loadComponent: () => import('./component/main-page/main-page.component').then(m => m.MainPageComponent),
  children: [
    {
      path: 'session-expired',
      loadComponent: () => import('./component/session-expired/session-expired.component').then(m => m.SessionExpiredComponent)
    },
    {
      path: 'login',
      canActivate: [LoginPageGuard],
      loadComponent: () => import('./component/login/login.component').then(m => m.LoginComponent)
    },
    {
      path: '',
      canActivate: [AuthGuard],
      loadComponent: () => import('./component/users-area/users-area.component').then(m => m.UsersAreaComponent),
      children: [
        {
          path: 'suspendedTenant',
          data: { title: 'Suspended Tenant' },
          canActivate: [SuspendedTenantGuard],
          loadComponent: () => import('./component/suspended-tenant/suspended-tenant.component').then(m => m.SuspendedTenantComponent)
        },
        {
          path: '',
          canActivateChild: [SelectedTenantGuard],
          loadComponent: () => import('./component/selected-tenant-area/selected-tenant-area.component').then(m => m.SelectedTenantAreaComponent),
          children: [
            {
              path: 'dashboard',
              data: { title: 'Dashboard' },
              loadComponent: () => import('./component/dashboard/dashboard.component').then(m => m.DashboardComponent)
            },
            {
              path: 'userManagement',
              data: { title: 'User Management' },
              loadComponent: () => import('./component/user-management/user-management.component').then(m => m.UserManagementComponent)
            },
            {
              path: 'pricing',
              canActivate: [PricingAndSubtenantsGuard],
              data: { title: 'Pricing & Virtual Tenants' },
              loadComponent: () => import('./component/pricing-and-virtualtenants/pricing-and-virtualtenants.component').then(m => m.PricingAndVirtualtenantsComponent),
              children: [
                {
                  path: '',
                  loadComponent: () => import('./component/pricing-and-virtualtenants/price-list/price-list.component').then(m => m.PriceListComponent)
                },
                {
                  path: 'sub-tenants',
                  canActivate: [SubTenantsAreaGuard],
                  loadComponent: () => import('./component/pricing-and-virtualtenants/sub-tenants/sub-tenants.component').then(m => m.SubTenantsComponent)
                },
                {
                  path: 'pricing-plans',
                  canActivate: [SubTenantsAreaGuard],
                  loadComponent: () => import('./component/pricing-and-virtualtenants/pricing-plans/pricing-plans.component').then(m => m.PricingPlansComponent)
                },
                {
                  path: 'about-sub-tenants',
                  canActivate: [SubTenantsAreaGuard],
                  loadComponent: () => import('./component/pricing-and-virtualtenants/about-sub-tenants/about-sub-tenants.component').then(m => m.AboutSubTenantsComponent)
                }
              ]
            },
            { path: '', redirectTo: '/dashboard', pathMatch: 'full' }
          ]
        },
        {
          path: 'getstarted',
          data: { title: 'Get Started' },
          loadComponent: () => import('./component/get-started/get-started.component').then(m => m.GetStartedComponent)
        },
        {
          path: 'userSettings',
          canActivate: [OrdersOrAccountGuard],
          loadComponent: () => import('./component/user-settings/user-settings.component').then(m => m.UserSettingsComponent)
        },
        {
          path: 'myOrders',
          data: { title: 'My Orders' },
          canActivate: [OrdersOrAccountGuard],
          loadComponent: () => import('./component/my-tenants/my-tenants.component').then(m => m.MyTenantsComponent)
        },
        {
          path: 'exportData',
          loadComponent: () => import('./component/cost-explorer/cost-explorer.component').then(m => m.CostExplorer)
        },
        {
          path: 'apiAccess',
          data: { title: 'API Access' },
          loadComponent: () => import('./component/api-access/api-access.component').then(m => m.ApiAccessComponent)
        },
        {
          path: 'notifications',
          loadComponent: () => import('./component/notifications/notifications.component').then(m => m.NotificationsComponent)
        },
        {
          path: 'priceList',
          loadComponent: () => import('./component/pricing-and-virtualtenants/price-list/price-list.component').then(m => m.PriceListComponent)
        }
      ]
    }
  ]
}, {
  path: 'callback',
  loadComponent: () => import('./component/callback/callback.component').then(m => m.CallbackComponent)
}];

